import React from 'react';
import './Navbar.css';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userId = localStorage.getItem('motoTaksiUserId');
  const isLoggedIn = !!userId;

  const handleLoginClick = () => {
    if (isLoggedIn) {
      navigate('/profile');
    } else {
      navigate('/auth');
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handlePostClick = () => {
    if (isLoggedIn) {
      navigate('/elanyarat');
    } else {
      navigate('/auth');
    }
  };

  const handleMotoClick = () => {
    if (isLoggedIn) {
      navigate('/motosifarish');
    } else {
      navigate('/auth');
    }
  };

  const handleAboutClick = () => {
    navigate('/haqqimizda');
  };

  const handleContactClick = () => {
    navigate('/elaqe');
  };

  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy');
  };

  const handleLotoreyaClick = () => {
    navigate('/lotoreya');
  }

  const handleYukleClick = () => {
    navigate('/yukle');
  }

  const handleSifarisQrupuClick = () => {
  navigate('/sifaris');
};

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="logo" onClick={handleLogoClick}>MotoTaksi.az</div>
        <div className="navbar-buttons">
          <button className="login-btn" onClick={handleLoginClick}>
            {isLoggedIn ? 'Hesabım' : 'Daxil Ol'}
          </button>
          <button className="post-btn" onClick={handlePostClick}>Pulsuz Elan Yerləşdir</button>
          <button className="moto-btn" onClick={handleMotoClick}>Moto Taksi Sifariş Et</button>
          <button className="privacy-policy-btn" onClick={handlePrivacyPolicyClick}>Məxfilik Siyasəti</button>
          <button className="about-btn" onClick={handleAboutClick}>Haqqımızda</button>
          <button className="contact-btn" onClick={handleContactClick}>Əlaqə</button>
          <a
            className="whatsapp-btn"
            href="https://chat.whatsapp.com/BiWK6xphZBaIReuja0PM4K?mode=ac_t"
            target="_blank"
            rel="noopener noreferrer"
          >
            Qrupa Qoşul
          </a>
          {location.pathname !== '/lotoreya' && (
            <button className="lotoreya-btn" onClick={handleLotoreyaClick}>
              🎁 Lotoreya 
            </button>
          )}

          <button 
  className="sifarisqrupu-btn" 
  onClick={handleSifarisQrupuClick}
>
  Sifariş Qrupu
</button>

          {location.pathname !== '/yukle' && (
            <button className="yukle-btn" onClick={handleYukleClick}>
              Yüklə
            </button>
          )}

        </div>
      </div>
    </nav>
  );
};

export default Navbar;

